export const steps = [
  {
    target: '.stepBarraPesquisa',
    content: 'Neste campo você pode realizar pesquisas rápidas de informações presentes nas colunas da tabela.',
    disableBeacon: true,
    spotlightPadding: 4,
    styles: {
      spotlight: {
        marginTop: 10,
        marginBottom: 5,
      },
    },
  },
  {
    target: '.stepCaixaSelecao',
    content:
      'Acionando essa seta ao lado da caixa de seleção, você tem a escolha de selecionar todos os registros exibidos no resultado da pesquisa, todos os registros da página e desmarcar todos.',
    spotlightPadding: -2,
  },
  {
    target: '.stepIconeOrdenacaoDefault',
    content: 'Com este ícone você consegue reordenar os registros exibidos no resultado da pesquisa.',
    styles: {
      spotlight: {
        marginTop: '13px',
        marginLeft: '129px',
        maxHeight: '20px',
        maxWidth: '20px',
      },
    },
    placement: 'right-start',
  },
  {
    target: '.stepIconeEditar',
    content: 'Acione este ícone quando desejar fazer a edição de algum registro.',
    spotlightPadding: 5,
  },
  {
    target: '.stepIconeExcluir',
    content: 'Acione este ícone quando desejar fazer a exclusão de algum registro.',
    spotlightPadding: 5,
  },
  {
    target: '.stepRodape',
    content:
      'No rodapé da página você consegue visualizar a quantidade de registros selecionados, escolher a quantidade de registros que deseja visualizar por página, visualizar quantos registros foram exibidos no total e selecionar a página desejada.',
    spotlightPadding: -20,
    styles: {
      spotlight: {
        maxWidth: '1000px',
      },
    },
  },
  {
    target: '.stepPlusButton',
    content:
      'Acionando este ícone, o sistema exibirá as opções para cadastrar um novo registro e excluir mais de um registro em uma única vez.',
    styles: {
      spotlight: {
        borderRadius: 50,
      },
    },
  },
];
